import loadScript from './loadScript';

// Heavy third-party SDKs that are only needed on specific, later steps of the
// application flow. They are lazy-loaded the first time their step is reached
// instead of being eagerly downloaded on the landing page (/intro). Each loader
// is idempotent (see loadScript), so it is safe to call as a preload on mount
// and again at the point of use.

// Socure WebSDK (document / identity verification) — used on the ID verify step.
export const SOCURE_WEBSDK_SRC = 'https://websdk.socure.com/bundle.js';
export const loadSocureWebSDK = () => loadScript(SOCURE_WEBSDK_SRC);

// Mitek Science SDK (proof-of-identity image validation) — used on the documents
// step. Absolute path keeps it route-independent; the SDK still resolves its own
// worker/chunk files via the `mitekSDKPath` option passed at call time.
export const MITEK_SDK_SRC = '/js/vendor/mitek-science-sdk.js';
export const loadMitekSDK = () => loadScript(MITEK_SDK_SRC);
